function Resource({ value, active, locked, onClick }) {
  return (
    <div
      className={`
        flex items-center justify-center w-10 h-10 md:w-14 md:h-14 rounded-lg cursor-pointer transition-all duration-200
        ${active
          ? 'animate-fade-selected shadow-glow-primary border border-primary/40'
          : 'bg-base-700/50 border border-white/[0.06] hover:border-white/[0.15] hover:bg-base-700'}
        ${locked ? 'cursor-default' : ''}
      `}
      onClick={onClick}>
        <img
          src={`${process.env.PUBLIC_URL}/images/${value}.png`}
          alt={value}
          className="w-6 h-6 md:w-9 md:h-9 pointer-events-none"/>
    </div>
  );
}

export default Resource;
